module.exports = __webpack_public_path__ + "d558ee2c58111a5cb6710a488cc858c2.png";